const SameAsDirective = function () {
    return {
        require: 'ngModel',
        restrict: 'A',

        link: function (scope, elm, attrs, ngModel: ng.INgModelController) {
            ngModel.$validators.sameAs = function (modelValue) {
                return modelValue === scope[attrs.sameAs];
            };

            scope.$watch(attrs.sameAs, function () {
                ngModel.$validate();
            })
        }
    }
};

export { SameAsDirective };